module.exports = __webpack_public_path__ + "static/media/ckn_restaurante.e25709d2.jpg";